import { css, Theme } from "@emotion/react";

export const container = () =>
    css({
        marginLeft: -40,
        marginRight: -40,
    });

export const element = () =>
    css({
        paddingLeft: 40,
        paddingRight: 40,
    });

export const horizontalScroll =
    (
        needScroll: boolean,
        allWidthBottomFixed: boolean,
        allWidth: boolean,
        allWidthLast: boolean,
        headerSticky: boolean
    ) =>
    (theme: Theme) =>
        css({
            ...(allWidth
                ? {
                      borderTop: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
                      borderBottom: theme.candy.border.solid,
                  }
                : {}),
            ...(allWidthLast
                ? {
                      borderBottom: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
                  }
                : {}),
            ...(needScroll ? { borderTop: theme.candy.border.solid } : {}),
            ...(allWidthBottomFixed
                ? {
                      boxShadow: `0 -3px 5px 0 ${theme.candy.legacy.shadowColor}`,
                      borderTop: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
                  }
                : {}),
            ...(headerSticky
                ? {
                      boxShadow: `0 3px 5px 0 ${theme.candy.legacy.shadowColor}`,
                      borderBottom: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
                  }
                : {}),
        });

export const header = (theme: Theme) =>
    css({
        borderBottom: theme.candy.border.solid,
    });

export const contentContainer = css({
    position: "relative",
});
